export default [
  {
    id: '46c3f5b9-27f1-4cec-9dd2-d6cfd0b20fd',
    name: 'resourceManagement',
    path: '/resource-management',
    meta: { title: 'identityServer管理' },
    component(resolve) {
      require(['./views/index'], resolve)
    },
    children: [
      {
        id: 'c77fd9bb-6164-459f-8336-d8ffbb8af055',
        path: 'api-resource',
        name: 'apiResource',
        component(resolve) {
          require(['./views/ApiResource.vue'], resolve)
        },
        meta: {
          title: 'API资源管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: false,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: false,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: false,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: false,
            },
          },
        },
      },
      {
        id: 'f4ab809c-ddfd-44ce-9eda-ef84a9fecc39',
        path: 'client',
        name: 'client',
        component(resolve) {
          require(['./views/Client.vue'], resolve)
        },
        meta: {
          title: '客户端管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: false,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: false,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: false,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: false,
            },
          },
        },
      },
      {
        id: '7c5d0d10-9f48-420a-a7d0-89a0695ac390',
        path: 'identify',
        name: 'identify',
        component(resolve) {
          require(['./views/Identify.vue'], resolve)
        },
        meta: {
          title: '身份资源管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: false,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: false,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: false,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: false,
            },
          },
        },
      },
      {
        id: '7929234d-49aa-4a6a-a063-59154b005971',
        path: 'api-scope',
        name: 'apiScope',
        component(resolve) {
          require(['./views/ApiScope.vue'], resolve)
        },
        meta: {
          title: 'API范围管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: false,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: false,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: false,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: false,
            },
          },
        },
      },
    ],
  },
]
